$(window).on('load', function() {
  // TryNow Code
  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  let isTryNowCollection = window.location.pathname.includes('collections/try-before-you-buy')
  let tryLink = getCookie('_tn_gate') === 'gated_link'
  // TryNow Code
  $('.product-card .color-swatch').click(function() {
    
    var product_card = $(this).parent().parent();
    var product_url = $(this).attr('product_url');
    var swatch_title = $(this).attr('title');
    var swatch_description = $(this).attr('description');
    var swatch_availability = $(this).attr('swatch_availability');
    var swatch_id = $(this).attr('swatch_id');
  
    product_card.find('.swatch-title').text(swatch_title)
    product_card.find('.swatch-description').text(swatch_description);

    product_card.find('.product-card-atc').attr('variant-id', swatch_id);
    product_card.find('.product-card-atc').attr('available', swatch_availability);
  
    if (swatch_availability == 'true') {
      product_card.find('.product-card-atc').attr('href', 'javascript:void(0)')
      // TryNow Code
      if(isTryNowCollection && tryLink){
        product_card.find('.product-card-atc-title').text('Try Before You Buy');
      }else{
        product_card.find('.product-card-atc-title').text('Add to Bag');
      }
      // TryNow Code
    } else {
      product_card.find('.product-card-atc').attr('href', product_url)
      product_card.find('.product-card-atc-title').text('Coming Soon');
    }
  
  });
  
  $('.product-card-default-atc').click(function(e) {
    if ($(this).find('.product-card-atc-title').text() == 'Coming Soon') {} 
    else {
      e.preventDefault();
       var variant_id = $(this).attr('variant-id');
       var variant_img = $(this).attr('variant-img');
       var product_title = $(this).attr('product-title');
       var variant_title = $(this).attr('variant-title');
       var variant_description = $(this).attr('variant-description');
  
       $('#cartModalImg').attr('src', variant_img);
       $('#cartModalTitle').html(product_title);
       $('#cartModalVariant').html(variant_title);
  
       jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          "id": variant_id,
          "quantity": 1
        },
        dataType: 'json',
        success: function() {
          
          
          jQuery.getJSON('/cart.js', function(cart) { 
            var cart_total = '$' + (cart.total_price / 100).toFixed(2);
            var total_left_for_free_shipping = ((5000 - cart.total_price) / 100).toFixed(2);
            var currency = cart.currency;
  
            $('.bag-total').html(cart_total);
            
            if (cart.total_price > 5000) { //change here for free shipping amount
              $('.cart-modal-free-shipping').html('Congratulations! You got free shipping and a free full size gift')
            } else {
              $('.cart-modal-free-shipping').html('You are $' + total_left_for_free_shipping + ' away from a free full size gift and free shipping');
            }
            
          });
  
          $('.cart-modal').css('visibility','visible');
          $('.cart-modal').css('opacity','1');
  
        }
      });
    }
  });
  
  $('.product-card-atc').click(function(e) {
    if ($(this).find('.product-card-atc-title').text() == 'Coming Soon') {} 
      
    else {
  
      var swatches = $(this).siblings('.product-card-swatch');
      var swatch_info = $(this).parent().find('.product-card-swatch-info');
      
      if (swatches.hasClass('open')){
  
        if ($(this).attr('available') == 'true') {
          $(this).parent().find('input').each(function() {
             if ($(this)[0].checked) {
               var variant_id = $(this).attr('variant-id');
               var variant_img = $(this).attr('variant-img');
               var product_title = $(this).attr('product-title');
               var variant_title = $(this).attr('variant-title');
               var variant_description = $(this).attr('variant-description');
        
               $('#cartModalImg').attr('src', variant_img);
               $('#cartModalTitle').html(product_title);
               $('#cartModalVariant').html(variant_title);
             }
          });
          var variant_id = parseInt($(this).attr('variant-id'));

          // TryNow Code
          let data = {
            "id": variant_id,
            "quantity": 1
          }
          if(isTryNowCollection && tryLink){
            data.selling_plan = parseInt($(this).attr('variant-selling-plan'))
          }
          // TryNow Code
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,  // TryNow Code. Use the data variable instead of using the object here 
            dataType: 'json',
            success: function() {
              
              
              jQuery.getJSON('/cart.js', function(cart) { 
                var cart_total = '$' + (cart.total_price / 100).toFixed(2);
                var total_left_for_free_shipping = ((5000 - cart.total_price) / 100).toFixed(2);
                var currency = cart.currency;

                // TryNow Code
                let tryNowTotalPrice = 0;
                
                cart.items.forEach(function(item) {
                  if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')) {
                    tryNowTotalPrice += item.final_line_price;
                  }
                });
                
                if(tryNowTotalPrice > 0){
                  $('.bag-total').html('$' + ((cart.total_price - tryNowTotalPrice)/100).toFixed(2));
                }else{
                  $('.bag-total').html(cart_total);
                }
                // TryNow Code
                
                if (cart.total_price > 5000) { //change here for free shipping amount
                  $('.cart-modal-free-shipping').html('Congratulations! You got free shipping and a free full size gift')
                } else {
                  $('.cart-modal-free-shipping').html('You are $' + total_left_for_free_shipping + ' away from a free full size gift and free shipping');
                }
                
              });
  
              $('.cart-modal').css('visibility','visible');
              $('.cart-modal').css('opacity','1');
  
              swatches.removeClass('open');
              swatch_info.removeClass('open');
            }
          });
        
          
        } else if ($(this).attr('available') == 'false') {
  
          
        } else {
          swatches.removeClass('open');
          swatch_info.removeClass('open');
  
        }
        
      } else {
        swatches.addClass('open');
        swatch_info.addClass('open');
      }
    }
  });

});